import * as manageTypes from './manageProjectType'
import Search from '../manageProject/search/search'
import useManageProjectType from './useManageProject'
import { Container, Grid, Typography, Button, makeStyles } from '@material-ui/core'

//View
const ManageProjectView = (props: manageTypes.ManageProjectView) => {
    const classes = useStyles()
    const screenHeight = window.innerHeight
    return (
        // <div style={{ height: `calc(${screenHeight}px - 113px)`, width: '100%' }}>
        //     <Search />
        // </div>
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <div style={{ height: `calc(${screenHeight}px - 240px)`, width: '100%' }}>
                    <Search />
                </div>
            </Grid>
        </Container>
    )
}
//Controller
const ManageProject = (props: manageTypes.ManageProjectType) => {
    const manageProjectModel = useManageProjectType(props)
    return <ManageProjectView {...manageProjectModel} />
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
}))

export default ManageProject
